export const ERROR_OLAS_LIST = 'movilidad/reportecobranza/error-olas-list';
export const RECEIVE_OLAS_LIST = 'movilidad/reportecobranza/receive-reportecobranza-list';
export const  RECEIVE_OLAS_DET = 'movilidad/reportecobranza/receive-reportecobranza-det';
export const REQUEST_OLAS_LIST = 'movilidad/reportecobranza/request-reportecobranza-list';
export const RESTART_STATE = 'movilidad/reportecobranza/restart_state';
export const SET_MASK = 'movilidad/reportecobranza/set-mask';
export const SET_ORDER = 'movilidad/reportecobranza/set-order';
export const SET_SELECTED_ROW = 'movilidad/reportecobranza/set-selected-row';
export const UPDATE_FIELD_FILTER = 'movilidad/reportecobranza/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'movilidad/reportecobranza/set-selected-row';